exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custcomment-enter-active,\r\n.custcomment-leave-active {\r\n  transition-duration: 1s;\r\n  transition-property: height, opacity, transform;\r\n  /*transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);\r\n    overflow: hidden; */\n}\n.custcomment-enter {\r\n  opacity: 0;\r\n  transform: translate(2em, 0);\n}\n.custcomment-leave-active {\r\n  opacity: 0;\r\n  transform: translate(2em, 0);\n}\r\n", ""]);

// exports
